import { MicrocartButton } from '@vue-storefront/core/modules/cart/components/MicrocartButton.ts'

export default {
  methods: {
    openMicrocart () {
      this.$store.dispatch('cart/load')
      this.$store.dispatch('ui/toggleMicrocart')

      if (window.innerWidth < 991) {
        this.$bus.$emit('hide-burger-menu')
        this.$bus.$emit('close-burger')
        this.$bus.$emit('hide-overlay-in-shop')
        this.$bus.$emit('change-close-btn')
      }
    },
    isInt (n) {
      return n % 1 === 0;
    }
  },
  computed: {
    totalQuantity () {
      // Data field renamed to 'quantity'
      return this.quantity;
    }
  },
  mixins: [
    MicrocartButton
  ]
}
